import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../services/axiosInstance";
import { API_ENDPOINTS } from "../services/api/apiConfig";

export const useAdminMutations = () => {
    const queryClient = useQueryClient();

    const createMutation = useMutation({
        mutationFn: async (formData: any) => {
            const response = await axiosInstance.post(API_ENDPOINTS.USERS.CREATE, formData);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['admin', 'accounts'] });
            queryClient.invalidateQueries({ queryKey: ['admin', 'stats'] });
        },
    });

    const deleteMutation = useMutation({
        mutationFn: async (id: number) => {
            const response = await axiosInstance.delete(API_ENDPOINTS.ADMINS.DELETE(id));
            return response.data;
        },
        onMutate: async (id: number) => {
            await queryClient.cancelQueries({ queryKey: ['admin', 'accounts'] });
            const previousAccounts = queryClient.getQueryData<any>(['admin', 'accounts']);

            if (previousAccounts) {
                queryClient.setQueryData(['admin', 'accounts'], (old: any) => {
                    if (!old) return old;
                    // Handle both array and paginated object structures
                    if (Array.isArray(old)) {
                        return old.filter((acc: any) => acc.id !== id);
                    }
                    if (old.items) {
                        return {
                            ...old,
                            items: old.items.filter((acc: any) => acc.id !== id),
                            totalItems: (old.totalItems || 1) - 1
                        };
                    }
                    return old;
                });
            }

            return { previousAccounts };
        },
        onError: (_err, _id, context) => {
            if (context?.previousAccounts) {
                queryClient.setQueryData(['admin', 'accounts'], context.previousAccounts);
            }
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['admin', 'accounts'] });
            queryClient.invalidateQueries({ queryKey: ['admin', 'stats'] });
        },
    });

    return {
        createAdmin: createMutation,
        deleteAdmin: deleteMutation,
    };
};
